(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geolizr-cart-notification"] && !Shopify.designMode) return;
  try {
    
  class CartNotification {
    init(data) {
      this.settings = data;
      if(typeof data.demo !== "undefined") {
        this.geoData = {country: {"code": data.demo}};
        this.showNotification();
      } else {
        Geolizr.getGeoData((data) => {
          this.geoData = data;
          this.showNotification();
        });
      }
    }

    getNotification() {
      if(this.settings.notifications.length > 0) {
        let filteredData = this.settings.notifications.filter((data) => { return data.countries.indexOf(this.geoData.country.code) !== -1; });
        return filteredData[0];
      }

      return false;
    }

    showNotification() {
      let notification = this.getNotification();
      if(notification) {
        document.querySelector("#geolizr-cart-note [data-title]").textContent = notification.title;
        document.querySelector("#geolizr-cart-note [data-body]").innerHTML = notification.body;
      } else {
        document.querySelector("#geolizr-cart-note div").style.display = 'none';
      }
    }
  }

  Geolizr.cartNote = new CartNotification();
  Geolizr.cartNote.init(Geolizr.cartNotification);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geolizr-fallback-currency"]) return;
  try {
    
  class GeolizrCurrencyFallback {
    init(currency) {
      this.currency = currency;
      this.observer();
    }

    observer() {
      Geolizr.addEventListener('currency.api', () => {
        if(Geolizr.isAutoSwitchCurrency()) {
          let isAutoSet = typeof Geolizr.cookie.get('geolizr-currency-auto') !== 'undefined';
          let isCurrencyValid = typeof Geolizr.moneyFormats[Geolizr.geoData.currency.code] == 'object';
          let isFallbackCurrencyValid = typeof Geolizr.moneyFormats[this.currency] == 'object';
          if(isCurrencyValid == false && isAutoSet == false && isFallbackCurrencyValid == true) {
            Geolizr.cookie.set('geolizr-currency-auto', '1');
            setTimeout(() => {
              Geolizr.setCurrency(this.currency);
            }, 600);
          }
        }
      })
    }

  }

  if(Geolizr.fallbackCurrencyEnabled) {
    let waitTimeout = 0;
    Geolizr.init($ => {
      if(waitTimeout > 0) {
        clearTimeout(waitTimeout);
      }
      waitTimeout = setTimeout(() => {
        Geolizr.currencyFallback = new GeolizrCurrencyFallback();
        Geolizr.currencyFallback.init(Geolizr.fallbackCurrency);
      }, 600)
    });
  }

  } catch(e) { console.error(e); }
})();
})();
